import { Grid } from "@mui/material";
import Page from "src/components/Page";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Header from "./components/Header";
import RighIlustration from "./components/RightIliustration";
import LoginContent from "./LoginContent";

// ----------------------------------------------------------------------

export const Login2 = () => {
	const mdDown = useResponsive("down", "md");
	const isMobile = useResponsive("down", "sm");

	const { translate } = useLocales();

	return (
		<Page title={translate("login.title")}>
			{!isMobile && <Header />}
			<Grid
				container
				sx={{
					height: "100vh",
					alignItems: isMobile ? "inherit" : "center",
					backgroundColor: "white"
				}}
			>
				<Grid item xs={12} md={6}>
					<LoginContent />
				</Grid>
				<Grid item sx={{ backgroundColor: "white" }} xs={0} md={6}>
					{!mdDown && <RighIlustration />}
				</Grid>
			</Grid>
		</Page>
	);
};

export default Login2;
